import { render, staticRenderFns } from "./MercedesPostEnquiryConsentComponent.vue?vue&type=template&id=e2972c32"
import script from "./MercedesPostEnquiryConsentComponent.vue?vue&type=script&lang=ts"
export * from "./MercedesPostEnquiryConsentComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports